import { QueryClient } from '@tanstack/react-query';

import { ApiRequestError } from '@/services/apiClient';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,

      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError) {
          if (error.status === 0) return failureCount < 2;
          if (error.status >= 400 && error.status < 500) return false;
        }

        return failureCount < 2;
      },
    },

    mutations: {
      retry: false,
    },
  },
});

export const queryKeys = {
  auth: { me: ['auth', 'me'] as const },

  newsletters: {
    all: ['newsletters'] as const,
    list: (params: Record<string, unknown>) => ['newsletters', 'list', params] as const,
    detail: (id: string) => ['newsletters', 'detail', id] as const,
    attachments: (id: string) => ['newsletters', 'detail', id, 'attachments'] as const,
  },

  galleries: {
    all: ['galleries'] as const,
    list: (params: Record<string, unknown>) => ['galleries', 'list', params] as const,
    detail: (id: string) => ['galleries', 'detail', id] as const,
  },

  quotes: {
    detail: (id: string) => ['quotes', 'detail', id] as const,
  },

  facilities: {
    detail: (id: string) => ['facilities', 'detail', id] as const,
  },

  media: {
    all: ['media'] as const,
    list: (params: Record<string, unknown>) => ['media', 'list', params] as const,
    folders: ['media', 'folders'] as const,
  },

  dashboard: { stats: ['dashboard', 'stats'] as const },

  auditLogs: {
    list: (params: Record<string, unknown>) => ['audit-logs', 'list', params] as const,
  },
} as const;
